import zh from "@/common/lang/zh";
import en from "@/common/lang/en";
export default {
	zh,
	en,
}